import { create } from 'zustand';
export const useAuditPanel = create((set)=>({
        auditId: null,
        open: (auditId)=>set({
                auditId
            }),
        close: ()=>set({
                auditId: null
            })
    }));
